import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { UserService, AuthService } from 'services';

interface Props {
	onClose?: any;
}

class ModalCreateUser extends React.Component<Props> {

	state = {
		form: {
			name: '',
			lastname: '',
			password: '',
			password_confirmation: '',
			phone: '',
			email: ''
		},
	}

	submit = async (e: any) => {
		e.preventDefault();
		await UserService.admin.registerAdmin({
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha creado el usuario correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-update-user">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-6">
							<Input
								value={ this.state.form.name }
								label="Nombre"
								name="name"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.lastname }
								label="Apellido"
								name="lastname"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.email }
								label="Correo electrónico"
								name="email"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								value={ this.state.form.phone }
								type="number"
								label="Teléfono"
								name="phone"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								label="Contraseña"
								type="password" 
								name="password"
								onChange={ this.change } />
						</div>
						<div className="col-md-6">
							<Input
								label="Repetir Contraseña"
								type="password" 
								name="password_confirmation"
								onChange={ this.change } />
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreateUser;